import { t } from 'i18next';
import { z } from 'zod';

import { zu } from '@/lib/zod/zod-utils';
import { RoleType } from '@/services/api';

export const zFormFieldsCompanyUser = () =>
  z.object({
    name: zu.string.nonEmpty(z.string(), {
      required_error: t('auth:users.data.name.required'),
    }),
    surname: zu.string.nonEmpty(z.string(), {
      required_error: t('auth:users.data.surname.required'),
    }),
    email: zu.string.email(z.string(), {
      required_error: t('auth:users.data.email.required'),
      invalid_type_error: t('auth:users.data.email.invalid'),
    }),
    role: z.enum(
      [...Object.values(RoleType), 'CompanyAdmin'] as unknown as [
        string,
        ...Array<string>,
      ],
      {
        required_error: t('auth:users.data.role.required'),
      }
    ),
  });
export type FormFieldsCompanyUser = z.infer<
  ReturnType<typeof zFormFieldsCompanyUser>
>;
